module.exports = __webpack_public_path__ + "fa2214bfdf625fe81e2dbd3d9eb442cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/daikanyama.png
// module id = 70
// module chunks = 0